<template>
    <CTabs variant="tabs" class="nav-tabs-boxed"> 
        <CTab title="Como Conheceu">
            <crud-base
                :url="url"
                :columns="columns"
                :onDelete="() => {}"
                :onUpdate="() => {}"
                :onStore="() => {}"
                :enableSearch="true"
                :formInputs="formInputs"
                :checkAlerts="true"
                primaryKey="id"
            />
        </CTab>
    </CTabs>
</template>

<script>
import CrudBase from "../../components/crud/CrudBase";
import {
  schemaBoolean,
  schemaTextField
} from "@/helpers/form";
import { yesNoRepresentation } from "@/helpers/transformers";
export default {
  name: "como-conheceu",
  components: {
    CrudBase,
  },
  data() {
    return {
      url: "/admin/como-conheceu",
      columns: [
        {
          label: "ID",
          field: "id",
          sortable: false
        },
        {
          label: "Descrição",
          field: "descricao",
          sortable: false
        }, 
        { 
          label: "Ativo", 
          field: "ativo", 
          sortable: false, 
          representedAs: (row) => yesNoRepresentation(row.ativo)
        }
      ], 
      formInputs: {
        descricao: schemaTextField("Descrição", true, 6),
        ativo: schemaBoolean('Ativo', true, 2, 1, 1), 
      },
    };
  }, 
};
</script>
